export type MbmtReportMode =
  | 'trips'
  | 'live'
  | 'shed'
  | 'punctuality'
  | 'alerts'
  | 'energy'
  | 'intel'
  | 'schedule-intel'
  | 'trip-alerts'
  | 'dead-mileage'
  | 'schedule-trips'

export const DEFAULT_MBMT_REPORT_MODE: MbmtReportMode = 'trips'

export const MBMT_REPORT_MODES: {
  id: MbmtReportMode
  label: string
  hint: string
}[] = [
  { id: 'trips', label: 'Duty log', hint: 'Closed and open legs from site_trip_leg, with SoC/km, kWh/km, discharge/km and regen/km (charge excluded from regen).' },
  { id: 'intel', label: 'Route & schedule intelligence', hint: 'p50/p85 by route × direction × time-of-day × bus model, against the timetable — short / tricky for the authority.' },
  { id: 'schedule-intel', label: 'Schedule intelligence', hint: 'p50/p85 by schedule code × time-of-day, against that specific schedule’s own timetable — not blended across every schedule on a route.' },
  { id: 'live', label: 'Live trips', hint: 'On-duty buses: schedule, route, driver, plate, SoC, speed.' },
  { id: 'shed', label: 'Inshed / outshed', hint: 'Depot GPS visits and scheduled sheds for the IST day.' },
  { id: 'punctuality', label: 'Late / early', hint: 'Confirmed scheduled vs actual by route and kind.' },
  { id: 'alerts', label: 'Alerts summary', hint: 'site_ours_alert + site_netradyne_alert, rolled by kind × category × route, and by vehicle and by driver, for the IST day range.' },
  { id: 'energy', label: 'Energy', hint: 'Closed legs with SoC/km, kWh/km, discharge/km and regen/km.' },
  { id: 'trip-alerts', label: 'Trip alerts', hint: 'Harsh brake/accel, overspeed, unscheduled stop and excessive idling, per scheduled trip.' },
  { id: 'dead-mileage', label: 'Dead mileage', hint: 'Dead / short / lost distance as a share of scheduled distance, by vehicle and ISO week.' },
  { id: 'schedule-trips', label: 'Trip log (planned vs actual)', hint: 'One row per scheduled trip: TIMS planned start/end vs GPS depot-boundary actual start/end. For past days, a vehicle that ran a second schedule code that day may be missing one of its trips — today is unaffected.' },
]

export function parseMbmtReportMode(raw: string | undefined): MbmtReportMode {
  if (raw && MBMT_REPORT_MODES.some((m) => m.id === raw)) return raw as MbmtReportMode
  return DEFAULT_MBMT_REPORT_MODE
}
